import $ from 'jquery';

export default function() {
  var $btn = $('.js_callback_popup_btn');
  var $popup = $('.js_callback_popup');

  $btn.on('click', function(e) {
    e.preventDefault();
    $popup.show();
  });
}
 